import React from "react"

export default function IndustryFeature(props) {
  return (
    <section className="industryFeature" id={props.featureID}>
      <div className={`featureContainer ${ props.featureLayout }`}>
        <div className="featureContent">
          <h1 className="featureHeading">{props.featureHeading}</h1>
          <p className="featureDescription"><em>{props.featureTitle}</em> {props.featureDescription}</p>
        </div>
        <div className="featurePreview">
          {props.featureImage}
        </div>
      </div>
    </section>
  )
}
